module.exports = __webpack_public_path__ + "static/media/play-stone-boss-4.80dfa596.png";